<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Transfer {{firearmTypeName}}</h2>
  <mat-dialog-content class="dialog-content">
    <div>
      <form [formGroup]="form">

        <div *ngIf="hasPendingActions">
          <div class="crud-item-section">
            <span class="crud-editor-warning">Currently this {{firearmTypeName}} has assignment actions
              pending. Please progress these before transferring the firearm.</span>
          </div>
        </div>

        <div *ngIf="currentlyIssued && !hasPendingActions">
          <div class="crud-item-section">
            <span class="crud-editor-info">{{firearmTypeName}} is currently issued and cannot be transferred. Reassign
              to storage
              before transferring.</span>
          </div>
        </div>

        <div *ngIf="!currentlyIssued && !hasPendingActions">
          <div class="crud-item-section">
            <span>Transfer a firearm in storage from its current Business Unit / Cost Centre to another Business Unit / Cost Centre.</span>
          </div>
          <div class="crud-item-section" *ngIf="assigneeConflictsWithPoolManager && transferWithinBusinessUnit">
            <span class="crud-editor-warning">This {{firearmTypeName}} is a Pool {{firearmTypeName}} currently managed
              by {{poolManagerUsername}}. <br/>
              When the Handover for Transfer completes, the Pool manager will be automatically <br/> 
              changed to {{storageAssigneeUsername}}, is within Business Unit '{{businessUnitDisplay(item.businessUnit)}}'.</span>
          </div>
          <div class="crud-item-section" *ngIf="assigneeConflictsWithPoolManager && !transferWithinBusinessUnit">
            <span class="crud-editor-warning">This {{firearmTypeName}} is a Pool {{firearmTypeName}} currently managed
              by {{poolManagerUsername}}. <br/> 
              When the Handover for Transfer completes, the Pool will be closed, because the <br/>
              transfer is between Business Units, the Pool details would be invalidated by this transfer.</span>
          </div>


          <div class="crud-item-section">
            <mat-form-field class="select-half-width" matTooltip="Select a Business Unit from the list">
              <mat-label i18n="@@type.Asset.businessUnit">Business Unit</mat-label>
              <mat-select formControlName="businessUnit" id="businessUnit" [(ngModel)]="item.businessUnit"
                (ngModelChange)="businessUnitChanged($event)" placeholder="Business Unit"
                [compareWith]="businessUnitCompare">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
                  {{businessUnitDisplay(businessUnit)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div class="crud-item-section">
            <mat-form-field class="select-half-width" matTooltip="Select a Cost Centre from the list">
              <mat-label i18n="@@type.Asset.costCentre">Cost Centre</mat-label>
              <mat-select formControlName="costCentre" id="costCentre" [(ngModel)]="item.costCentre"
                (ngModelChange)="costCentreChanged($event)" placeholder="Cost Centre" [compareWith]="costCentreCompare">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
                  {{costCentre?.ccId}} - {{costCentre?.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="crud-item-section">
            <mat-form-field matTooltip="Select a Storage Assignee from the list"
              [matTooltipDisabled]="disabledTooltip(this.storageAssignee)" class="crud-item-input-wider">
              <mat-label i18n="@@type.FirearmTransferDialogData.storageAssignee">Storage Assignee</mat-label>
              <mat-select formControlName="storageAssignee" id="storageAssignee"
                (ngModelChange)="storageAssigneeChanging($event)" [(ngModel)]="item.storageAssignee"
                (ngModelChange)="storageAssigneeChanged($event)" #storageAssignee
                [compareWith]="storageAssigneeCompare">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let assignee of storageAssigneeSelectionList" [value]="assignee">
                  {{storageAssigneeDisplay(assignee)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="crud-item-section">
            <mat-form-field matTooltip="Select a Location from the list"
              [matTooltipDisabled]="disabledTooltip(this.location)" class="crud-item-input-wider">
              <mat-label i18n="@@type.FirearmTransferDialogData.location">Storage Location</mat-label>
              <mat-select formControlName="location" id="location" (ngModelChange)="locationChanging($event)"
                [(ngModel)]="item.location" (ngModelChange)="locationChanged($event)" #location placeholder="Location"
                [compareWith]="locationCompare">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let location of locationSelectionList" [value]="location">
                  {{locationDisplay(location)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="crud-item-section">
            <mat-form-field matTooltip="Comments" class="crud-item-input-verywide">
              <mat-label i18n="@@type.FirearmTransferDialogData.comments">Comments</mat-label>
              <textarea matInput formControlName="comments" id="comments" [(ngModel)]="item.comments" maxlength="1000"
                placeholder="Comments">
              </textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="!isFirearmTransferEnabled()"
      (click)="firearmTransfer()">Initiate {{firearmTypeName}} Transfer</button>
    <button mat-raised-button color="accent" (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
  <div class="crud-editor-error-list" *ngIf="getFormErrorList().length > 0">
    <br>
    <h2>Errors:</h2>
    <div *ngFor="let error of getFormErrorList()" class="crud-editor-err-msg">{{error}}</div>
  </div>
</div>